import type { ReactNode } from 'react'
import s from './styles.module.css'
import ArrowRightIcon from  '@assets/svg/button-icons/arrow-right.svg?react';


const styledLabel = (text: string, icon?: ReactNode) => {
	return (
	  <div className={s.container_wrapper}>
			<div className={s.label_wrapper}>
				<span className={s.icon_label}>{icon}</span>
				<span className={s.text_label}>{text}</span>
		  </div>
			<ArrowRightIcon />
		</div>
	)
}

export default styledLabel